import React, { useState, useEffect, useContext } from "react";
import SiteWeather from "./SiteWeather";
import $ from 'jquery';
import { Select } from 'antd';
import SessionManager from "../../routes/SessionManager";
import Moment from "react-moment";
import { Context } from "../../views/app";

const TimelapseDashboard = (props) => {
    let appContext = useContext(Context);
    const [user, setUser] = useState(appContext.user);
    const [site_locations, setSiteLocations] = useState(null);
    const [site_selected, setSiteSelected] = useState(null);
    const [videos, setVideos] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user.site_locations) {
            let siteDefault = user.site_selected;
            if (!siteDefault)
                siteDefault = getDefaultSite(user.site_locations);
            setSiteLocations(user.site_locations);
            setSiteSelected(siteDefault);
        } else {
            fetchSiteLocations();
        }
    }, []);

    useEffect(() => {
        if (site_selected !== null) {
            fetchSiteLocationZones();
            fetchVideos();
        }
    }, [site_selected]);

    let fetchSiteLocationZones = () => {
        var data = {
            customer_id: user.site_selected.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {

                if (res && res.status && res.status.code === 200) {
                    console.log(site_selected);
                    let zone_prefs = user.zone_prefs_for_sites ? user.zone_prefs_for_sites[site_selected.site_id] : null;
                    var filteredZones = (res.data).filter(zone => zone.location_adminstatus === "Up");

                    if (zone_prefs && zone_prefs.length > 0) {
                        var sortedZones = filteredZones.sort((a, b) => {
                            return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                        });
                    } else {
                        sortedZones = filteredZones;
                    }

                    //User accessible zones only.
                    let user_zones = user.user_zones;
                    if (user_zones && user_zones[site_selected.site_id]) {
                        let zonesAllowed = user_zones[site_selected.site_id];
                        if (zonesAllowed.length > 0) {
                            let sortedZonesFinal = [];
                            for (let s of sortedZones) {
                                if (zonesAllowed.includes(s.location_id)) {
                                    sortedZonesFinal.push(s);
                                }
                            }
                            sortedZones = sortedZonesFinal;
                        }
                    }

                    var sessionMgr = new SessionManager();
                    var user_info = sessionMgr.readCookie('user');
                    user_info.zones = sortedZones;
                    sessionMgr.storeCookie('user', user_info);
                    setUser(user_info);
                } else {
                    let sessionMgr = new SessionManager();
                    let user_info = sessionMgr.readCookie('user');
                    user_info.zones = [];
                    sessionMgr.storeCookie('user', user_info);
                    setUser(user_info);
                }
            },
            (res) => {

            });
    }

    let fetchVideos = () => {
        setLoading(true);
        let request = {
            user_login: user.user_login,
            user_token: user.user_token,
            app_name: 'SITESUPT',
            form_input: {
                operation: 'latest-timelapse-videos-by-site',
                site_id: user.site_selected.site_id,
                timezone: user.site_selected.site_iana_timezone
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/videos-history',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(request),
                dataType: "json"
            }
        ).then((res) => {
            if (res && res.status.code === 200) {
                let videos = res.data.records ? res.data.records : [];
                let zone_map = [];
                if (user.user_zones)
                    for (let z in user.user_zones)
                        if (z === user.site_selected.site_id)
                            zone_map = zone_map.concat(user.user_zones[z]);

                if (videos.length > 0 && zone_map.length > 0)
                    videos = videos.filter(v => zone_map.includes(v.location_id));

                setVideos(videos);
                setLoading(false);
            }
        }, (err) => {
            setLoading(false);
        });
    }

    let fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state !== 'Inactive') : [];
                    let loc = 'site_name';
                    site_locations = site_locations.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);
                    if (site_locations && site_locations.length > 0) {
                        let siteDefault = getDefaultSite(site_locations);
                        if (siteDefault) {
                            var sessionMgr = new SessionManager();
                            var user_info = sessionMgr.readCookie('user');
                            user_info.site_selected = siteDefault;
                            user_info.site_locations = site_locations;
                            sessionMgr.storeCookie('user', user_info);
                            onSiteLocationChange(siteDefault);
                            fetchSiteLocationZones();
                        }
                    }
                    fetchVideos();
                }
            });
    }

    let getDefaultSite = (site_locations) => {
        var siteDefault = null;
        let defaultSiteId = user.site_id;

        if (!defaultSiteId)
            defaultSiteId = user.site_selected.site_id;

        if (defaultSiteId) {
            for (let s of site_locations)
                if (s.site_id + '' === defaultSiteId + '') {
                    siteDefault = s;
                    break;
                }
        }

        if (!siteDefault)
            siteDefault = site_locations[0];

        return siteDefault;
    }

    let onSiteLocationChange = (site_selected) => {
        var sessionMgr = new SessionManager();
        var user_info = sessionMgr.readCookie('user');
        user_info.site_selected = site_selected;
        delete user_info.zones;
        delete user_info.zone_selected;
        appContext.updateUser(user_info);
        setUser(user_info);
        setSiteSelected(site_selected);
    }

    let viewTimelapseHistory = (location_id) => {
        var sessionMgr = new SessionManager();
        var user = sessionMgr.readCookie('user');
        console.log(user.zones);
        for (let l of user.zones) {
            if (l.location_id === location_id)
                user.zone_selected = l;
        }
        sessionMgr.storeCookie('user', user);
        window.location = '/videos/timelapse-video';
    }

    const videosCount = videos ? videos.length : 0;
    const zoneCardClassName = 'col-md-' + ((videosCount > 0 && videosCount < 4) ? (12 / videosCount) : 4);
    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row mb-4 px-0">
                    <div className={"col-md-4 pl-4 mb-2"} style={{ lineHeight: '24px' }}>
                        <Select
                            style={{ width: '200px' }}
                            className='font-size-13 w-175 site_picker'
                            dropdownMatchSelectWidth={false}
                            filterOption={(input, option) =>
                                (option.label).toLowerCase().includes(input.toLowerCase())
                            }
                            showSearch
                            value={site_selected && site_selected.site_id}
                            onChange={(...args) => {
                                onSiteLocationChange(args[1].site, false, true);
                                // let currentPage = window.location.href;
                                // window.location = currentPage;
                            }}
                            options={site_locations && site_locations.map((a) => { return { value: a.site_id, label: a.site_name + ', ' + a.site_city, site: a }; })}
                            placeholder="Choose Site"
                        />
                    </div>

                    <div className={"col-md-4 mb-2 text-md-center"}>
                        {site_selected && <div className="bg-white border-rounded font-size-12 py-custom"><SiteWeather site={site_selected}></SiteWeather></div>}
                    </div>

                </div>

                <div className="row video-container">
                    {!loading && videos && videos.map((video, i) => (
                        <div className={zoneCardClassName + " mt-3"} key={i}>
                            <div className="card bg-shadow">
                                <div className="card-body p-0" id={"videos"}>
                                    <video width="100%" height="auto" style={{ objectFit: 'cover' }} controls className={"card-img-top video-player " + (video.video_type === 'Time-Lapse Video' ? 'timelapse-video' : 'live-video')} video_container={"videos"}>
                                        <source src={video.signed_url} type="video/mp4" />
                                        <source src={video.signed_url} type="video/ogg" />
                                    </video>
                                </div>
                                <div className="card-footer border-0 bg-light" >
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span className="text-app font-size-12 font-weight-700" >
                                                Created By: {video.created_by}
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span className="text-app pull-right font-size-12 font-weight-300" >
                                                <Moment format="MMM DD, YYYY HH:mm" tz={user.site_selected.site_iana_timezone}>{video.sec_timestamp * 1000}</Moment>
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span className="text-app font-size-12 font-weight-300">
                                                {video.location_name}
                                            </span>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <span className="text-app font-size-12 font-weight-300">
                                                <button className="btn btn-sm btn-primary" onClick={() => viewTimelapseHistory(video.location_id)}>View History</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {!videos && <div className="col-12 mt-5 text-bold">Fetching videos ...</div>}
                    {videos && videos.length === 0 && <div className="col-12 mt-5 text-bold">No videos found ...</div>}
                </div>
            </div>
        </React.Fragment>
    );
}

export default TimelapseDashboard;